import React from 'react'
import '../stylings/topHeader.css'
import { Link } from 'react-router-dom'
import { FaFacebook, FaLocationDot, FaMobileScreenButton, FaYoutube } from 'react-icons/fa6'
import { MdMailOutline } from 'react-icons/md'
import { IoLogoWhatsapp } from 'react-icons/io'
import { TbBrandInstagramFilled } from 'react-icons/tb'

const TopHeader = () => {
    return (
        <div className='top-header-container'>
            <div className="header-wrapper row">
                <div className="column col-md-3">
                    <div className="left-wrapper">
                        <ul>
                            <li>
                                <Link to={'https://wa.me/8595015369'} target='_blank'>
                                    <span><IoLogoWhatsapp /></span>
                                    <span className='brand-name'>Whatsapp</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={'https://www.facebook.com/share/A9jp8wy2G8JHEgKS/?mibextid=qi2Omg'} target='_blank'>
                                    <span><FaFacebook /></span>
                                    <span className='brand-name'>Facebook</span>
                                </Link>
                            </li>
                            <li>
                                <Link>
                                    <span><FaYoutube /></span>
                                    <span className='brand-name'>Youtube</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={'https://www.instagram.com/wtl_foundation?igsh=enZoM2xscjRqZ3Nl'} target='_blank'>
                                    <span><TbBrandInstagramFilled /></span>
                                    <span className='brand-name'>Instagram</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="column col-md-9 d-none d-sm-block">
                    <div className="right-wrapper">
                        <ul className='justify-content-end gap-2'>
                            <li>
                                <Link to={'tel:+918595015369'} className='gap-1'>
                                    <FaMobileScreenButton />
                                    <span className='contact-info'>+91-8595015369</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={'mailto:wtlfoundation91@gmail.com'} className='gap-1'>
                                    <MdMailOutline />
                                    <span className='contact-info'>wtlfoundation91@gmail.com</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={'https://www.google.com/maps?ll=28.472245,77.138838&z=15&t=m&hl=en&gl=IN&mapclient=embed&cid=5552148819634866693'} target='_blank' className='gap-1'>
                                    <FaLocationDot />
                                    <span className=''>Phase 6, Aya Nagar Delhi - 110047</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopHeader
